import { render, staticRenderFns } from "./seriesCatButton.vue?vue&type=template&id=1d24451f&"
import script from "./seriesCatButton.vue?vue&type=script&lang=js&"
export * from "./seriesCatButton.vue?vue&type=script&lang=js&"
import style0 from "./seriesCatButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "seriesCatButton.vue"
export default component.exports